const getCurrentTime = (): Date => {
  return new Date();
};

export default getCurrentTime;
